const surfacesEndPoint = "/tennis/api/TechnicalApi/GetClassifiedSurfaces";
const ballsEndPoint = "/tennis/api/TechnicalApi/GetCertifiedBalls";

export async function getBalls() {
  const response = await fetch(`${process.env.HOST}${ballsEndPoint}`);
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getSurfaces() {
  const response = await fetch(`${process.env.HOST}${surfacesEndPoint}`);
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
